import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  constructor(private cookieService: CookieService) {}

  removeAll(): void {
    this.cookieService.deleteAll('/', environment.cookieDomain);
  }

  removeItem(key: string): void {
    this.cookieService.delete(key);
  }

  setItem(key: string, value: string): void {
    this.cookieService.set(key, value);
  }

  getItem(key: string): string {
    return this.cookieService.get(key);
  }
}
